import React, { useState, useEffect } from "react"
import SbEditable from "storyblok-react"
import queryString from "query-string"
import countryTelephoneCode from "country-telephone-code"

import { StoryblokFormField } from "../StoryblokFormField"
import { cookiePrefill, initialFields, extractUniversityInfo, extractSchoolInfo } from "../utils/index"
import { addCookieData, addNewCookieData } from "../../../helpers/handleCookies"
import ButtonV2 from "../../button-v2"

import { eventInformation } from "../../../helpers/handleCookies"

function salesforcePrefill(f, contact) {
    if (f.name === "firstName") {
        if (contact.FirstName) return contact.FirstName
    } else if (f.name === "lastName") {
        if (contact.LastName) return contact.LastName
    } else if (f.type === "email") {
        if (contact.Email) return contact.Email
    } else if (f.name === "countryCode") {
        if (contact.countryCode) return contact.countryCode
    } else if (f.name === "stateCode") {
        if (contact.State) return contact.State
    } else {
        return ""
    }
}

function prefillFormFields(fields, contact) {
    const parsedFields = []
    fields.forEach((f) => {
        let prefill = undefined

        prefill = salesforcePrefill(f, contact)
        if (!prefill && f.cookie) {
            prefill = cookiePrefill(f.cookie)
        }

        if (!prefill && f.default) {
            prefill = f.default
        }

        const isValid = prefill ? true : null

        const field = {
            ...f,
            id: f._uid,
            value: prefill,
            valid: isValid,
            default: prefill,
        }

        /* Required field and no prefill from cookie or salesforce, so ensure its not hidden */
        if (f.required && !prefill) {
            field.hidden = false
        }

        // If field type telephone add additional properties
        if (f.type === "tel") {
            const countryCookie = cookiePrefill("uCountry")
            if (countryCookie) {
                field.countryCode = `+${countryTelephoneCode(countryCookie)}`
                field.isoCountry = countryCookie
            } else {
                field.countryCode = "+1"
                field.isoCountry = "US"
            }
        }

        if (field.dependant_field) {
            const dep = parsedFields.find(d => d.name === field.dependant_field)
            const isrequired = f.required
            let feVal
            if (dep) {
                feVal = dep.type === 'tel' ? dep.isoCountry : dep.value
            }

            if (feVal === field.dependant_value || feVal === true || (field.dependant_value && feVal.length > 0 && field.dependant_value.includes(",") && field.dependant_value.includes(feVal.toLowerCase()))) {
                field.hidden = false
                // field.required = true
            }
            else {
                field.hidden = true
                field.required = false
            }
        }

        parsedFields.push(field)
    })

    return parsedFields
}

export const EventForm = ({
    isDark,
    blok,
    redirects,
    campaign_id_options,
    campaign_id_label,
    multi_campaign
}) => {

    const [contact, setContact] = useState({})
    const [fields, setFields] = useState(
        initialFields(
            blok.fields,
            blok?.privacy,
            blok?.termsAndConditions,
            campaign_id_options,
            campaign_id_label,
            multi_campaign
        )
    )

    const addInfo = (eventId) => {
        eventId = fields.find(field => field.name === "campaignID") && fields.find(field => field.name === "campaignID").value
        eventInformation(eventId)
    }

    const [loading, setLoading] = useState(false)
    const [startedForm, setStartedForm] = useState(false)
    const form_implementation = "storyblok"

    useEffect(() => {
        if (typeof window !== "undefined") {
            const queryParams = queryString.parse(window.location.search)
            const contactId = queryParams.S

            window.dataLayer.push({
                event: "form_view",
                eventMeta: {
                    form_platform: form_implementation,
                    form_type: blok.formType,
                },
            })

            if (contactId) {
                fetch(`${process.env.GATSBY_SALESFORCE_API}/hulthousing/services/apexrest/GetContactInfo`,
                    {
                        method: "post",
                        body: JSON.stringify({ contactID: contactId }),
                    }
                )
                    .then((resp) => {
                        return resp.json()
                    })
                    .then((data) => {
                        setContact(JSON.parse(data))
                        setFields(prefillFormFields(fields, JSON.parse(data)))
                    })
            } else {
                setContact({})
                setFields(prefillFormFields(fields, contact))
            }
        }
    }, [])

    function handleValueChange(id, obj) {
        let fe = [...fields]

        // Find field and set value/valid properties
        const idx = fe.findIndex((el) => el.id === id)

        if (fe[idx].type === "tel") {
            fe[idx].countryCode = obj.countryCode
            fe[idx].isoCountry = obj.isoCountry
        } else if (fe[idx].name === "selectYourProgram") {
            fe[idx].selectLabel = obj.selectLabel
        }

        if (fe[idx].type === "text" || fe[idx].type === "lookup") {
            fe[idx].value = obj.value.replace("'", "’")
        } else {
            fe[idx].value = obj.value
        }

        // If current valid is null it must be true before being invalid
        if (
            (fe[idx].valid === null && obj.valid) ||
            fe[idx].valid ||
            fe[idx].valid === false
        ) {
            fe[idx].valid = obj.valid
        }

        /* Check if it has dependant fields */
        const name = fe[idx].name
        const feVal = fe[idx].type === 'tel' ? fe[idx].isoCountry : fe[idx].value

        fe.forEach((f) => {
            const dependant_array = f.dependant_value && f.dependant_value.split(', ')
            if (name === f.dependant_field && feVal) {
                if (feVal === f.dependant_value || feVal === true || (f.dependant_value && feVal.length > 0 && f.dependant_value.includes(",") && dependant_array.includes(feVal.toLowerCase()))) {
                    f.hidden = false
                    //   f.required = isrequired
                }
                else {
                    f.hidden = true
                    f.required = false
                }
            } else if (name === f.dependant_field && !feVal) {
                f.hidden = true
                f.required = false
            }
        })

        if (!startedForm) {
            window.dataLayer.push({
                event: "form_start",
                eventMeta: {
                    form_platform: form_implementation,
                    form_type: blok.formType,
                },
            })
            setStartedForm(true)
        }

        setFields(fe)
    }

    function checkValidity() {
        let allValid = true
        let checkedFields = [...fields]

        let invalidFields = []

        checkedFields.forEach((f) => {
            // Mark the fields that are required but not valid
            if (!f.valid && f.required) {
                allValid = false
                f.valid = false
                invalidFields.push(f.name)
            }
        })

        return [allValid, checkedFields, invalidFields.join(",")]
    }

    function submitForm() {
        // Construct JSON
        let json = {}
        let brochureSlug = null

        fields.forEach((f) => {
            if (f.name === "privacy") {
                // Do not add privacy to json
            } else if (f.name === "comments") {
                // Add label with delimiter
                json[f.name] = `${f.label} : ${f.value}`
            } else if (f.type === "tel") {
                json[f.name] = `${f.countryCode}${f.value}`
            } else {
                json[f.name] = f.value
            }

            // Determine redirect url if redirects are based on a field
            if (
                f.name === blok.fieldLevelDependency &&
                blok.redirectType === "fieldLevel"
            ) {
                const redirect = redirects.filter(
                    (redirect) =>
                        redirect?.node?.value.toLowerCase() === f.value.toLowerCase()
                )
                brochureSlug = redirect ? redirect[0]?.node?.name : null
            }
        })

        json["formType"] = blok.formType

        // Add fallback campaign ID if field does not exist in forms
        json["campaignID"] = json["campaignID"] || blok?.campaignId

        window.dataLayer.push({
            user: {
                program: json["selectYourProgram"],
            },
        })

        const universityInfo = extractUniversityInfo(fields);
        const schoolInfo = extractSchoolInfo(fields);
        setLoading(true)

        fetch(`${process.env.GATSBY_INTEGRATION_API}`, {
            method: "post",
            headers: {
                "content-type": "application/json",
                "x-api-key": process.env.GATSBY_INTEGRATION_EVSU_API_KEY,
            },
            body: JSON.stringify({
                type: json.formType || undefined,
                program: json.selectYourProgram || undefined,
                firstName: json.firstName || undefined,
                lastName: json.lastName || undefined,
                email: json.email || undefined,
                phone: json.phoneNumber || undefined,
                country: json.countryCode || undefined,
                state: json.state || json.stateCode || undefined,
                city: json.city || undefined,
                address1: json.addressline1 || undefined,
                address2: json.addressline2 || undefined,
                postcode: json.postalcode || undefined,
                universityName: universityInfo.universityName || undefined,
                university: universityInfo.universityId || undefined,
                highSchoolName: schoolInfo.schoolName || undefined,
                highSchool: schoolInfo.schoolId || undefined,
                comments: json.comments || undefined,
                campus: json.campus || undefined,
                startTerm: json.startTerm || undefined,
                linkedin: json.linkedin || undefined,
                subject: json.subject || undefined,
                workExperience: json.workExperience || undefined,
                specialization: json.specialization || undefined,
                jobTitle: json.jobTitle || undefined,
                organisation: json.organisation || undefined,
                Company: json.Company || undefined,
                degreeType: json.degreeType || undefined,
                englishLevel: json.englishLevel || undefined,
                campaignId: json.campaignID || undefined,
                extraPrivacy: json.extraPrivacy || undefined,
                referralEmail: json.referralEmail || undefined,
                ...addNewCookieData(),
            }),
        })
            .then(() => {
                // Push submitForm event to GA
                window.dataLayer.push({
                    event: "hultedu_submitForm",
                    eventMeta: {
                        content: json["formType"],
                        timestamp: JSON.stringify(new Date()),
                    },
                })

                let getProgramValue = fields.find(field => field.name === "selectYourProgram") && fields.find(field => field.name === "selectYourProgram").value

                window.dataLayer.push({
                    event: "form_success",
                    eventMeta: {
                        form_platform: form_implementation,
                        form_type: json["formType"],
                        program: getProgramValue || "",
                        uniId: universityInfo.universityId || "",
                    },
                })

                // Set the redirection within setTimeout to prevent reset of loading
                setTimeout(() => {
                    if (blok.redirectType === "formLevel" && blok.formLevelLink) {
                        window.location = blok.formLevelLink
                    } else if (blok.redirectType === "fieldLevel" && brochureSlug) {
                        window.location = brochureSlug
                    }
                }, 500) // Short delay to ensure loading state persists momentarily before redirect
            })
            .catch((error) => {
                setLoading(false)
                console.log(error)
            })
    }

    function handleSubmit() {
        const valid = checkValidity()

        setFields(valid[1])

        addInfo()

        let getProgramValue = fields.find(field => field.name === "selectYourProgram") && fields.find(field => field.name === "selectYourProgram").value

        const universityInfo = extractUniversityInfo(fields);

        window.dataLayer.push({
            event: "form_submission",
            eventMeta: {
                form_platform: form_implementation,
                form_type: blok.formType,
                program: getProgramValue || "",
                uniId: universityInfo.universityId || "",
            },
        })

        if (valid[0]) {
            submitForm(fields)
        } else {
            // Invalid data, therefore send event to GA
            window.dataLayer.push({
                event: "hultedu_validationError",
                eventMeta: {
                    content: `${blok.formType} - ${valid[2]} `,
                    timestamp: JSON.stringify(new Date()),
                },
            })

            window.dataLayer.push({
                event: "form_validation_error",
                eventMeta: {
                    form_platform: form_implementation,
                    form_type: blok.formType,
                    fields: valid[2],
                },
            })
        }
    }

    return (
        <SbEditable content={blok}>
            {fields &&
                fields.map((field) => (
                    <StoryblokFormField
                        key={field._uid}
                        loading={loading}
                        isDark={isDark}
                        blok={field}
                        value={field.value}
                        onValueChange={handleValueChange}
                    />
                ))}
            <ButtonV2
                label={blok.buttonLabel}
                loading={loading}
                className="button-v2--primary"
                icon="ArrowRight"
                onClick={handleSubmit}
                type="submit"
            />
        </SbEditable>
    )
}
